/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Keep the configurable product-gallery dots synchronized with Flickity,
 * including media changes caused by swiping, arrows, thumbnails and variants.
 */
function initProductGalleryDots(root) {
  var scope = root || document;

  scope.querySelectorAll('.product-gallery').forEach(function (gallery) {
    if (gallery.dataset.mobileDotsInitialized === 'true') return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__dot'));

    if (!carousel) return;

    gallery.dataset.mobileDotsInitialized = 'true';

    var thumbnailList = gallery.querySelector('.product-gallery__thumbnail-list');
    var thumbnailScroller = thumbnailList && thumbnailList.parentNode;

    [thumbnailList, thumbnailScroller].forEach(function (element) {
      if (!element || element.productGalleryNativeScrollTo || typeof element.scrollTo !== 'function') return;

      element.productGalleryNativeScrollTo = element.scrollTo.bind(element);
      element.scrollTo = function (options, y) {
        if (options && typeof options === 'object') {
          element.productGalleryNativeScrollTo({
            top: options.top,
            left: options.left,
            behavior: 'auto'
          });
        } else {
          element.productGalleryNativeScrollTo(options, y);
        }
      };
    });

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.product-gallery__carousel-item'));
    var slidesByMediaId = {};
    var lastState = null;

    slides.forEach(function (slide) {
      slidesByMediaId[slide.dataset.mediaId] = slide;
    });

    var getActiveSlide = function () {
      return carousel.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)');
    };

    var getFlickityInstance = function () {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        var nativeInstance = window.Flickity.data(carousel);
        if (nativeInstance) return nativeInstance;
      }

      if (window.jQuery) {
        var jqueryInstance = window.jQuery(carousel).data('flickity');
        if (jqueryInstance) return jqueryInstance;
      }

      return null;
    };

    var prepareSlideImage = function (slide) {
      var image = slide && slide.querySelector('.product-gallery__image');
      if (!image) return;

      image.loading = 'eager';
      image.decoding = 'async';
      image.setAttribute('fetchpriority', 'high');
    };

    var revealGallerySlides = function () {
      slides.forEach(function (slide) {
        slide.classList.remove('product-gallery__carousel-item--hidden');
      });
    };

    var selectMedia = function (mediaId) {
      var targetSlide = slidesByMediaId[String(mediaId)];
      if (!targetSlide || targetSlide.classList.contains('is-filtered')) return false;

      revealGallerySlides();
      prepareSlideImage(targetSlide);

      var flickity = getFlickityInstance();
      if (flickity && typeof flickity.selectCell === 'function') {
        flickity.selectCell(targetSlide, false, false);
        return true;
      }

      if (getActiveSlide() === targetSlide) {
        syncDots();
        return true;
      }

      var availableSlides = slides.filter(function (slide) {
        return !slide.classList.contains('is-filtered');
      });
      var currentIndex = availableSlides.indexOf(getActiveSlide());
      var targetIndex = availableSlides.indexOf(targetSlide);

      if (targetIndex < 0) return false;
      if (currentIndex < 0) currentIndex = 0;

      var directionButton = gallery.querySelector(targetIndex > currentIndex ? '.slick-next' : '.slick-prev');
      var steps = Math.abs(targetIndex - currentIndex);

      if (!directionButton || steps === 0) return false;

      for (var step = 0; step < steps; step += 1) {
        directionButton.click();
      }

      return true;
    };

    var preloadAdjacentImages = function (activeSlide) {
      var availableSlides = slides.filter(function (slide) {
        return !slide.classList.contains('is-filtered');
      });
      var activeIndex = availableSlides.indexOf(activeSlide);

      [activeIndex - 1, activeIndex + 1].forEach(function (index) {
        var image = availableSlides[index] && availableSlides[index].querySelector('.product-gallery__image');

        if (!image || image.complete) return;

        image.loading = 'eager';
        image.decoding = 'async';
      });
    };

    var syncDots = function () {
      var activeSlide = getActiveSlide();
      var nextState = slides.map(function (slide) {
        var isFiltered = slide.classList.contains('is-filtered');
        var isActive = activeSlide === slide && !isFiltered;

        return (isFiltered ? '0' : '1') + (isActive ? '1' : '0');
      }).join('');

      if (nextState === lastState) return;

      lastState = nextState;

      dots.forEach(function (dot) {
        var slide = slidesByMediaId[dot.dataset.mediaId];
        var isFiltered = !slide || slide.classList.contains('is-filtered');
        var isActive = Boolean(slide && activeSlide === slide && !isFiltered);

        dot.hidden = isFiltered;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (activeSlide) preloadAdjacentImages(activeSlide);
    };

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        selectMedia(dot.dataset.mediaId);
      });
    });

    gallery.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.product-gallery__thumbnail');
      if (!thumbnail || !gallery.contains(thumbnail) || thumbnail.classList.contains('is-filtered')) return;

      event.preventDefault();
      event.stopPropagation();

      var mediaId = thumbnail.dataset.mediaId;
      var targetSlide = slidesByMediaId[String(mediaId)];
      if (!targetSlide) return;

      selectMedia(mediaId);
    });

    var syncScheduled = false;
    var observer = new MutationObserver(function () {
      if (syncScheduled) return;

      syncScheduled = true;
      window.requestAnimationFrame(function () {
        syncScheduled = false;
        syncDots();
      });
    });

    slides.forEach(function (slide) {
      observer.observe(slide, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden']
      });
    });

    gallery.productGalleryDotsObserver = observer;
    syncDots();
  });
}

function startProductGalleryDots() {
  initProductGalleryDots(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startProductGalleryDots);
} else {
  startProductGalleryDots();
}

document.addEventListener('shopify:section:load', function (event) {
  window.setTimeout(function () {
    initProductGalleryDots(event.target);
  }, 0);
});

document.addEventListener('shopify:section:unload', function (event) {
  event.target.querySelectorAll('.product-gallery').forEach(function (gallery) {
    if (gallery.productGalleryDotsObserver) {
      gallery.productGalleryDotsObserver.disconnect();
    }
  });
});

/**
 * Match the product-page recommendation navigation to the checkout dots while
 * keeping both Flickity (desktop) and native horizontal swiping (mobile) intact.
 */
function initCheckoutProductRecommendationDots(root) {
  var scope = root || document;
  var sliders = [];

  if (scope.matches && scope.matches('[data-product-recommendations-slider]')) {
    sliders.push(scope);
  }

  if (scope.querySelectorAll) {
    scope.querySelectorAll('[data-product-recommendations-slider]').forEach(function (slider) {
      sliders.push(slider);
    });
  }

  sliders.forEach(function (slider) {
    var track = slider.querySelector('[data-product-recommendations-track]');
    var productList = track && track.querySelector('.product-list');
    var dotsContainer = slider.querySelector('[data-product-recommendations-dots]');
    var cards = productList ? Array.prototype.slice.call(productList.querySelectorAll('.product-item')) : [];
    var dots = dotsContainer ? Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-product-recommendations-dot]')) : [];

    if (!track || !productList || cards.length < 2 || dots.length < 2) return;

    var signature = cards.length + ':' + dots.length;
    if (slider.checkoutRecommendationDotsSignature === signature) return;

    if (typeof slider.checkoutRecommendationDotsCleanup === 'function') {
      slider.checkoutRecommendationDotsCleanup();
    }

    slider.checkoutRecommendationDotsSignature = signature;

    var frame = null;
    var isFlickityActive = function () {
      return productList.classList.contains('flickity-enabled') && Boolean(productList.querySelector('.flickity-viewport'));
    };

    var getActiveIndex = function () {
      if (isFlickityActive()) {
        var selectedIndex = cards.findIndex(function (card) {
          return card.classList.contains('is-selected');
        });

        if (selectedIndex >= 0) return selectedIndex;
      }

      var trackLeft = track.getBoundingClientRect().left;
      var closestIndex = 0;
      var closestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    var updateDots = function () {
      frame = null;
      var activeIndex = getActiveIndex();

      dots.forEach(function (dot, index) {
        var isActive = activeIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    var scheduleUpdate = function () {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(updateDots);
    };

    var selectRecommendation = function (targetIndex) {
      var targetCard = cards[targetIndex];
      if (!targetCard) return;

      if (isFlickityActive()) {
        var currentIndex = getActiveIndex();
        var direction = targetIndex < currentIndex ? 'previous' : 'next';
        var navigationButton = productList.querySelector('.flickity-prev-next-button.' + direction);
        var steps = Math.abs(targetIndex - currentIndex);

        if (steps === 0) {
          scheduleUpdate();
          return;
        }

        if (navigationButton && steps > 0) {
          for (var step = 0; step < steps; step += 1) navigationButton.click();
          scheduleUpdate();
          return;
        }
      }

      var trackRect = track.getBoundingClientRect();
      var cardRect = targetCard.getBoundingClientRect();
      track.scrollTo({
        left: track.scrollLeft + cardRect.left - trackRect.left,
        behavior: 'smooth'
      });
    };

    var dotHandlers = dots.map(function (dot) {
      var handler = function (event) {
        event.preventDefault();
        selectRecommendation(parseInt(dot.dataset.productRecommendationsDot, 10));
      };

      dot.addEventListener('click', handler);
      return { dot: dot, handler: handler };
    });

    var classObserver = new MutationObserver(scheduleUpdate);
    classObserver.observe(productList, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });

    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    slider.checkoutRecommendationDotsRefresh = scheduleUpdate;
    slider.checkoutRecommendationDotsCleanup = function () {
      classObserver.disconnect();
      track.removeEventListener('scroll', scheduleUpdate);
      dotHandlers.forEach(function (entry) {
        entry.dot.removeEventListener('click', entry.handler);
      });
      if (frame !== null) window.cancelAnimationFrame(frame);
      slider.checkoutRecommendationDotsSignature = null;
    };

    scheduleUpdate();
  });
}

function startCheckoutProductRecommendationDots() {
  initCheckoutProductRecommendationDots(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startCheckoutProductRecommendationDots);
} else {
  startCheckoutProductRecommendationDots();
}

window.addEventListener('load', startCheckoutProductRecommendationDots);
window.addEventListener('resize', function () {
  document.querySelectorAll('[data-product-recommendations-slider]').forEach(function (slider) {
    if (typeof slider.checkoutRecommendationDotsRefresh === 'function') {
      slider.checkoutRecommendationDotsRefresh();
    }
  });
});

document.addEventListener('shopify:section:load', function (event) {
  window.setTimeout(function () {
    initCheckoutProductRecommendationDots(event.target);
  }, 0);
});

var checkoutProductRecommendationDotsObserver = new MutationObserver(function (mutations) {
  var shouldRefresh = mutations.some(function (mutation) {
    return Array.prototype.some.call(mutation.addedNodes, function (node) {
      return node.nodeType === 1 && (
        (node.matches && node.matches('[data-product-recommendations-dots], .product-item')) ||
        (node.querySelector && node.querySelector('[data-product-recommendations-dots], .product-item'))
      );
    });
  });

  if (shouldRefresh) {
    window.requestAnimationFrame(startCheckoutProductRecommendationDots);
  }
});

checkoutProductRecommendationDotsObserver.observe(document.documentElement, { childList: true, subtree: true });

/*
 * Experiência da sacola Wareplus.
 * A gaveta abre com o carrinho confirmado e ganha uma entrada
 * no histórico da página atual. Assim, voltar/arrastar no navegador apenas fecha
 * a sacola e mantém o visitante exatamente no produto que estava vendo.
 */
(function initWareplusDrawerExperience() {
  if (window.TerraWareplusDrawer) return;

  function boot() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer || !document.body) return;

    var isWareplus = drawer.querySelector('.just-wrapper-cart');
    var isDrawer = !window.theme || window.theme.cartType !== 'page';
    if (!isWareplus || !isDrawer) return;

    var overlay = document.getElementById('overlay');
    var closeTimer = null;
    var closingFromHistory = false;
    var pointerStart = null;
    var drawerHistoryKey = '__terraWareplusDrawer';
    var addRequest = null;
    var returnFocus = null;
    var rootPath = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

    function readCart() {
      var snapshot = drawer.querySelector('[data-wp-drawer-cart]');
      try { return snapshot ? JSON.parse(snapshot.textContent) : null; } catch (error) { return null; }
    }

    function renderConfirmedSection(html) {
      if (!html) return false;
      var rendered = new DOMParser().parseFromString(html, 'text/html').querySelector('#mini-cart');
      if (!rendered || !rendered.querySelector('.mini-cart__line-item')) return false;
      drawer.innerHTML = rendered.innerHTML;
      drawer.setAttribute('data-item-count', rendered.getAttribute('data-item-count') || '0');
      return true;
    }

    function notifyConfirmedCart(result, button, quantity) {
      var cart = readCart();
      if (cart) {
        document.querySelectorAll('.header__cart-count').forEach(function (count) {
          count.textContent = cart.item_count;
        });
        if (overlay) overlay.setAttribute('data-item-count', cart.item_count);
        try {
          if (window.TerraProductCartState) window.TerraProductCartState.applyCart(cart);
        } catch (error) {}
      }
      try {
        drawer.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true, detail: { cart: cart } }));
      } catch (error) {}
      try {
        document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: {
          button: button, variant: result, quantity: quantity, cart: cart, sectionsRendered: true
        } }));
      } catch (error) {}
    }

    function showAddError(button, message) {
      var scope = button.closest('[data-product-form-buttons]') || button.parentNode;
      var errorNode = scope.querySelector('[data-wp-cart-add-error]');
      if (!errorNode) {
        errorNode = document.createElement('p');
        errorNode.setAttribute('data-wp-cart-add-error', '');
        errorNode.setAttribute('role', 'alert');
        scope.appendChild(errorNode);
      }
      errorNode.textContent = message;
    }

    function add(button) {
      if (!button || button.disabled) return Promise.resolve();
      if (addRequest) return addRequest;
      var section = button.closest('[data-section-type="product"]');
      var form = button.closest('form[action*="/cart/add"], form.product-form') ||
        (section && section.querySelector('form[action*="/cart/add"], form.product-form')) ||
        document.querySelector('form[action*="/cart/add"], form.product-form');
      var productRoot = button.closest('[data-product-form-buttons]') || (section && section.querySelector('[data-product-form-buttons]'));
      var variantField = form && form.querySelector('[name="id"], [name="id[]"]');
      var variantId = String(button.getAttribute('data-variant-id') ||
        (variantField && variantField.value) ||
        (productRoot && productRoot.getAttribute('data-selected-variant-id')) || '').trim();
      if (!/^\d+$/.test(variantId)) {
        var jsonNode = section && section.querySelector('script[data-product-json]');
        try {
          var productData = jsonNode && JSON.parse(jsonNode.textContent);
          variantId = String((productData && productData.selected_variant_id) || '').trim();
        } catch (error) {}
      }
      if (!/^\d+$/.test(variantId)) {
        showAddError(button, 'Selecione uma opção do produto para adicionar à sacola.');
        return Promise.resolve();
      }
      var cart = readCart();
      var productId = productRoot && productRoot.getAttribute('data-product-id');
      var preventDuplicate = button.getAttribute('data-prevent-cart-duplicate') === 'true' || button.classList.contains('wp-sticky-add-to-cart');
      if (preventDuplicate && cart && cart.items.some(function (item) {
        return String(item.product_id) === String(productId) || String(item.variant_id) === String(variantId);
      })) {
        open();
        return Promise.resolve(cart);
      }
      var quantityField = form && form.querySelector('[name="quantity"], #quantityInput');
      var quantity = Math.max(1, Math.min(99, Number(quantityField && quantityField.value) || 1));
      var payload = new URLSearchParams();
      payload.set('id', variantId);
      payload.set('quantity', String(quantity));
      payload.set('sections', 'mini-cart');
      payload.set('sections_url', window.location.pathname);
      if (form) {
        new FormData(form).forEach(function (value, key) {
          if (key.indexOf('properties[') === 0 || key === 'selling_plan') payload.append(key, value);
        });
      }
      var priorError = productRoot && productRoot.querySelector('[data-wp-cart-add-error]');
      if (priorError) priorError.remove();
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      /* Shopify devolve o item e o HTML atualizado na mesma resposta da inclusão. */
      addRequest = fetch(rootPath + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: payload.toString()
      }).then(function (response) {
        return response.json().then(function (result) {
          if (!response.ok) throw new Error(result.description || result.message || 'Não foi possível adicionar o produto. Tente novamente.');
          return result;
        });
      }).then(function (result) {
        function complete(html) {
          if (!renderConfirmedSection(html)) throw new Error('O produto foi adicionado, mas não foi possível atualizar a sacola. Abra a sacola novamente.');
          open();
          notifyConfirmedCart(result, button, quantity);
          return result;
        }
        var html = result.sections && result.sections['mini-cart'];
        if (html && renderConfirmedSection(html)) {
          open();
          notifyConfirmedCart(result, button, quantity);
          return result;
        }
        /* Renderização ausente ou incompleta não autoriza repetir o POST. */
        return fetch(rootPath + 'cart?section_id=mini-cart', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (response) { if (!response.ok) throw new Error('Não foi possível atualizar a sacola.'); return response.text(); })
          .then(complete);
      }).catch(function (error) {
        showAddError(button, error.message || 'Não foi possível adicionar o produto. Tente novamente.');
      }).finally(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        addRequest = null;
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
      return addRequest;
    }

    function isOpen() {
      return drawer.getAttribute('aria-hidden') === 'false';
    }

    function cartToggles() {
      return document.querySelectorAll('[aria-controls="mini-cart"]');
    }

    function setToggleState(open) {
      cartToggles().forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      var nativeCart = drawer.terraNativeCartController;
      if (nativeCart) nativeCart.isMiniCartOpen = open;
    }

    function currentOrigin() {
      return window.location.pathname + window.location.search + window.location.hash;
    }

    function addDrawerHistoryEntry() {
      var state = window.history.state || {};
      if (state[drawerHistoryKey]) return;

      var nextState = {};
      Object.keys(state).forEach(function (key) { nextState[key] = state[key]; });
      nextState[drawerHistoryKey] = true;
      nextState.terraWareplusOrigin = currentOrigin();

      try {
        window.history.pushState(nextState, '', window.location.href);
      } catch (error) {
        /* O fechamento continua funcional mesmo em webviews restritivas. */
      }
    }

    function open(options) {
      options = options || {};
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      var wasOpen = isOpen();
      if (!wasOpen) {
        returnFocus = document.activeElement;
        addDrawerHistoryEntry();
      }
      if (drawer.querySelector('.mini-cart__line-item')) drawer.removeAttribute('data-wp-open-after-refresh');
      drawer.style.removeProperty('--wp-drawer-swipe-x');
      drawer.classList.remove('wp-wareplus-drawer--dragging');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('aria-modal', 'true');
      setToggleState(true);
      document.body.classList.add('mini-cart-is-open', 'wp-wareplus-drawer-open');
      if (overlay) {
        overlay.classList.remove('wp-wareplus-overlay--closing');
        overlay.classList.add('wp-wareplus-overlay--visible');
      }
      if (!wasOpen) {
        drawer.setAttribute('tabindex', '-1');
        drawer.focus({ preventScroll: true });
      }

      if (options.refresh) {
        window.setTimeout(function () {
          try {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { openMiniCart: false, scrollToTop: false }
            }));
          } catch (error) {}
        }, 0);
      }
    }

    function closeVisual() {
      if (!isOpen() && !document.body.classList.contains('wp-wareplus-drawer-open')) return;
      pointerStart = null;
      drawer.removeAttribute('data-wp-open-after-refresh');
      drawer.style.removeProperty('--wp-drawer-swipe-x');
      drawer.classList.remove('wp-wareplus-drawer--dragging');
      if (isOpen()) drawer.setAttribute('aria-hidden', 'true');
      drawer.removeAttribute('aria-modal');
      setToggleState(false);
      if (overlay) {
        overlay.classList.remove('wp-wareplus-overlay--visible');
        overlay.classList.add('wp-wareplus-overlay--closing');
      }

      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        document.body.classList.remove('mini-cart-is-open', 'wp-wareplus-drawer-open');
        if (overlay) overlay.classList.remove('wp-wareplus-overlay--closing');
        closeTimer = null;
        if (returnFocus && returnFocus.isConnected && returnFocus.getClientRects().length) {
          returnFocus.focus({ preventScroll: true });
        }
        returnFocus = null;
      }, 360);
    }

    function close() {
      var state = window.history.state || {};
      if (state[drawerHistoryKey]) {
        closingFromHistory = true;
        window.history.back();
        window.setTimeout(function () {
          if (closingFromHistory && isOpen()) {
            closingFromHistory = false;
            closeVisual();
          }
        }, 180);
        return;
      }
      closeVisual();
    }

    function preventAndClose(event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      close();
    }

    document.addEventListener('wareplus:drawer:open', function () {
      open();
    });

    function requestOpenAfterRefresh(event) {
      if (event.detail && event.detail.sectionsRendered) return;
      drawer.setAttribute('data-wp-open-after-refresh', 'true');
    }

    /* O tema emite este evento somente depois de o Shopify confirmar /cart/add.js. */
    document.addEventListener('product:added', requestOpenAfterRefresh, true);
    document.addEventListener('wareplus:drawer:open-after-refresh', requestOpenAfterRefresh, true);

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var toggle = target.closest('[data-action="toggle-mini-cart"]');
      if (toggle) {
        if (drawer.contains(toggle)) {
          preventAndClose(event);
          return;
        }

        if (!isOpen()) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          open({ refresh: true });
        } else {
          preventAndClose(event);
        }
        return;
      }

      if (overlay && target === overlay && isOpen()) preventAndClose(event);
    }, true);

    window.addEventListener('popstate', function () {
      closingFromHistory = false;
      if (isOpen()) closeVisual();
    });

    /* O foco pertence somente à gaveta visível; nenhum bloqueio fica na página após fechar. */
    document.addEventListener('focusin', function (event) {
      if (isOpen() && !drawer.contains(event.target)) drawer.focus({ preventScroll: true });
    });
    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        preventAndClose(event);
      } else if (event.key === 'Tab') {
        var controls = Array.prototype.filter.call(drawer.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'), function (control) {
          return !control.disabled && control.tabIndex >= 0 && control.getClientRects().length;
        });
        var first = controls[0];
        var last = controls[controls.length - 1];
        if (!first || (event.shiftKey && (document.activeElement === first || document.activeElement === drawer))) {
          event.preventDefault();
          (last || drawer).focus({ preventScroll: true });
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === drawer)) {
          event.preventDefault();
          first.focus({ preventScroll: true });
        }
      }
    });

    drawer.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'touch' || !isOpen()) return;
      if (event.target.closest('.mini-cart__recommendations, [data-cart-upsell-slider], .mini-cart__recommendations-list, .quantity-selector, input, button, a')) return;
      pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    }, { passive: true });

    drawer.addEventListener('pointermove', function (event) {
      if (!pointerStart || event.pointerId !== pointerStart.id) return;
      var distanceX = event.clientX - pointerStart.x;
      var distanceY = event.clientY - pointerStart.y;
      if (distanceX <= 0 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.15) return;

      drawer.classList.add('wp-wareplus-drawer--dragging');
      drawer.style.setProperty('--wp-drawer-swipe-x', Math.min(distanceX, drawer.clientWidth) + 'px');
    }, { passive: true });

    function finishSwipe(event) {
      if (!pointerStart || (event.pointerId != null && event.pointerId !== pointerStart.id)) return;
      var distanceX = event.clientX - pointerStart.x;
      var distanceY = event.clientY - pointerStart.y;
      var shouldClose = distanceX > Math.max(72, drawer.clientWidth * 0.18) && Math.abs(distanceX) > Math.abs(distanceY) * 1.15;
      pointerStart = null;
      drawer.classList.remove('wp-wareplus-drawer--dragging');
      drawer.style.removeProperty('--wp-drawer-swipe-x');
      if (shouldClose) close();
    }

    drawer.addEventListener('pointerup', finishSwipe, { passive: true });
    drawer.addEventListener('pointercancel', finishSwipe, { passive: true });

    var drawerObserver = new MutationObserver(function (mutations) {
      if (drawer.getAttribute('data-wp-open-after-refresh') === 'true') {
        var hasConfirmedItem = drawer.querySelector('.mini-cart__line-item, .mini-cart__line-item-list .product-item');
        if (hasConfirmedItem) {
          drawer.removeAttribute('data-wp-open-after-refresh');
          open();
        }
      }

      var changedVisibility = mutations.some(function (mutation) {
        return mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden' && mutation.oldValue !== drawer.getAttribute('aria-hidden');
      });
      if (changedVisibility && isOpen()) {
        addDrawerHistoryEntry();
        setToggleState(true);
        document.body.classList.add('mini-cart-is-open', 'wp-wareplus-drawer-open');
        if (overlay) {
          overlay.classList.remove('wp-wareplus-overlay--closing');
          overlay.classList.add('wp-wareplus-overlay--visible');
        }
      } else if (changedVisibility && !isOpen()) {
        closeVisual();
      }
    });
    drawerObserver.observe(drawer, { childList: true, attributes: true, attributeOldValue: true, attributeFilter: ['aria-hidden'] });

    window.TerraWareplusDrawer = {
      add: add,
      open: open,
      close: close,
      getCart: readCart,
      isOpen: isOpen
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
